module.exports = __webpack_public_path__ + "static/media/lightning.svg.a87085b2.png";